"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
const SingleSelectDropdownInput = _ref => {
  let {
    selectedItem,
    placeholder,
    getToggleButtonProps,
    itemToString,
    disabled,
    containsErrors,
    actionIconsPadding,
    inputProps
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.ToggleButton, getToggleButtonProps({
    disabled: disabled,
    containsErrors: containsErrors,
    actionIconsPadding: actionIconsPadding,
    ...inputProps
  }), selectedItem ? /*#__PURE__*/_react.default.createElement("span", null, itemToString(selectedItem)) : /*#__PURE__*/_react.default.createElement(_styles.StyledPlaceholder, null, placeholder));
};
SingleSelectDropdownInput.propTypes = {
  actionIconsPadding: _propTypes.default.any,
  containsErrors: _propTypes.default.any,
  disabled: _propTypes.default.any,
  getToggleButtonProps: _propTypes.default.func,
  inputProps: _propTypes.default.any,
  itemToString: _propTypes.default.func,
  placeholder: _propTypes.default.any,
  selectedItem: _propTypes.default.any
};
var _default = exports.default = SingleSelectDropdownInput;
SingleSelectDropdownInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SingleSelectDropdownInput",
  "props": {
    "actionIconsPadding": {
      "description": "",
      "type": {
        "name": "any"
      },
      "required": false
    },
    "containsErrors": {
      "description": "",
      "type": {
        "name": "any"
      },
      "required": false
    },
    "disabled": {
      "description": "",
      "type": {
        "name": "any"
      },
      "required": false
    },
    "getToggleButtonProps": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "inputProps": {
      "description": "",
      "type": {
        "name": "any"
      },
      "required": false
    },
    "itemToString": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "placeholder": {
      "description": "",
      "type": {
        "name": "any"
      },
      "required": false
    },
    "selectedItem": {
      "description": "",
      "type": {
        "name": "any"
      },
      "required": false
    }
  }
};